import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonContextualActions } from './ContextualActions.definition';
import { chameleonContextualActionSeparator } from './ContextualActionsSeparator.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonContextualActions({ prefix }), chameleonContextualActionSeparator({ prefix }));
}
